import type {} from '@mui/x-data-grid/themeAugmentation';

export const paletteEntreposto = {
  primary: {
    main: '#016625',
    variants: {
      '0': '#002B10',
      '10': '#013814',
      '20': '#01481A',
      '30': '#015D22',
      '40': '#016625',
      '50': '#348551',
      '60': '#55986D',
      '70': '#8AB99B',
      '80': '#B0D0BB',
      '90': '#D6E7DC',
      '95': '#E6F0E9',
      '100': '#ffffff',
    },
  },
  secondary: {
    main: '#016625',
    variants: {
      '0': '#002B10',
      '10': '#013814',
      '20': '#01481A',
      '30': '#015D22',
      '40': '#016625',
      '50': '#348551',
      '60': '#55986D',
      '70': '#8AB99B',
      '80': '#B0D0BB',
      '90': '#D6E7DC',
      '95': '#E6F0E9',
      '100': '#ffffff',
    },
  },
  'surface-background': {
    main: '#FFF8F8',
    contrast: '#EEDFE2',
  },
  outline: {
    main: '#837378',
  },
  terceary: {
    main: '#AD4E00',
    variants: {
      '0': '#000000',
      '10': '#301400',
      '20': '#4F2500',
      '30': '#703800',
      '40': '#934600',
      '50': '#AD4E00',
      '60': '#CE5C01',
      '70': '#F38530',
      '80': '#FFB782',
      '90': '#FFDCC5',
      '95': '#FFEDE3',
      '100': '#ffffff',
    },
  },
  text: {
    primary: '#000',
    dark: '#21191C',
    variant: '#514347',
  },
  button: {
    bg: '#FFF0F4',
    disabled: '#1d1b201f',
  },
  icon: {
    primary: '#390721',
  },
  drawer: {
    main: '#FFF',
  },
  selectedItem: {
    main: '#2962FF',
  },
  tableColumnHeader: {
    main: '#ECEFF1',
  },
  formCard: {
    main: '#FFF',
  },
};
